(function(){
  var fmt=new Intl.NumberFormat('pl-PL',{style:'currency',currency:'PLN'});
  function money(c){return fmt.format(c/100);}
  function data(h){if(!h._d){try{h._d=JSON.parse(h.querySelector('[data-nd-data]').textContent);}catch(e){h._d={variants:[],off:0};}}return h._d;}
  function st(h){if(!h._s){var d=data(h),i=0;d.variants.forEach(function(v,k){if(v.title==='Orzech'){i=k;}});h._s={mode:2,c:[i,i]};}return h._s;}
  function render(h){
    var s=st(h),d=data(h);
    var p1=d.variants[s.c[0]]?d.variants[s.c[0]].price:0;
    var p2=d.variants[s.c[1]]?d.variants[s.c[1]].price:0;
    var total=s.mode===2?p1+p2-d.off:p1;
    h.querySelectorAll('[data-nd-offer]').forEach(function(b){b.setAttribute('aria-checked',String(parseInt(b.dataset.ndOffer,10)===s.mode));});
    h.querySelectorAll('[data-nd-slot]').forEach(function(w){var n=parseInt(w.dataset.ndSlot,10);w.hidden=(n===2&&s.mode!==2);});
    h.querySelectorAll('[data-nd-color]').forEach(function(b){var slot=parseInt(b.dataset.slot,10)-1;b.setAttribute('aria-pressed',String(parseInt(b.dataset.idx,10)===s.c[slot]));});
    document.querySelectorAll('[data-nd-total]').forEach(function(e){e.textContent=money(total);});
    document.querySelectorAll('[data-nd-per]').forEach(function(e){e.textContent=s.mode===2?('('+money(Math.round(total/2))+' za sztukę)'):'';});
  }
  function showMedia(h,id){
    var t=h.querySelector('[data-nd-thumb][data-media="'+id+'"]');
    if(t){setMain(h,t);}
  }
  function setMain(h,t){
    var img=h.querySelector('[data-nd-main]');
    if(img){img.src=t.dataset.src;img.removeAttribute('srcset');img.alt=t.dataset.alt||'';}
    h.querySelectorAll('[data-nd-thumb]').forEach(function(x){x.setAttribute('aria-current',String(x===t));});
  }
  function add(h,btn){
    var s=st(h),d=data(h),items=[];
    var v1=d.variants[s.c[0]];
    if(!v1){return;}
    if(s.mode===2){
      var v2=d.variants[s.c[1]];
      if(v2.id===v1.id){items.push({id:v1.id,quantity:2});}else{items.push({id:v1.id,quantity:1});items.push({id:v2.id,quantity:1});}
    }else{items.push({id:v1.id,quantity:1});}
    document.querySelectorAll('[data-nd-add]').forEach(function(b){b.disabled=true;});
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){if(!r.ok){throw new Error('cart');}return r.json();})
      .then(function(){window.location.href='/cart';})
      .catch(function(){document.querySelectorAll('[data-nd-add]').forEach(function(b){b.disabled=false;});alert('Nie udało się dodać do koszyka. Spróbuj ponownie.');});
  }
  document.addEventListener('click',function(e){
    var h=e.target.closest('[data-nd-hero]')||document.querySelector('[data-nd-hero]');
    if(!h){return;}
    var o=e.target.closest('[data-nd-offer]');
    if(o&&h.contains(o)){st(h).mode=parseInt(o.dataset.ndOffer,10);render(h);return;}
    var c=e.target.closest('[data-nd-color]');
    if(c&&h.contains(c)){var s=st(h),slot=parseInt(c.dataset.slot,10)-1,idx=parseInt(c.dataset.idx,10);s.c[slot]=idx;if(slot===0){s.c[1]=(s.mode===2&&s._sync!==false)?s.c[1]:idx;var v=data(h).variants[idx];if(v&&v.media){showMedia(h,v.media);}}render(h);return;}
    var t=e.target.closest('[data-nd-thumb]');
    if(t&&h.contains(t)){setMain(h,t);return;}
    var a=e.target.closest('[data-nd-add]');
    if(a){add(h,a);}
  });
  function init(){
    document.querySelectorAll('[data-nd-hero]').forEach(function(h){
      render(h);
      var cta=h.querySelector('[data-nd-cta]'),bar=h.querySelector('[data-nd-sticky]');
      if(cta&&bar&&'IntersectionObserver' in window){
        new IntersectionObserver(function(en){var x=en[0];bar.classList.toggle('is-on',!x.isIntersecting&&x.boundingClientRect.top<0);},{threshold:0}).observe(cta);
      }
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);
})();
